export default __webpack_public_path__ + "dbb426227d900726ad0a5c9c998af5f1.svg";